import React, { createContext, useState, useEffect, useContext } from "react";
import axios from "axios";

// import { notification } from 'antd';
// import { jwtDecode } from 'jwt-decode';

// Create the AuthContext
const AuthContext = createContext();
export const useAuth = () => {
  return useContext(AuthContext);
};

// const getTokenExpiration = (token) => {
//   if (!token) return null;
//   const decodedToken = jwtDecode(token);
//   const decodedInMiliseconds = decodedToken.exp * 1000;
//   return decodedInMiliseconds
// };

// Create a provider component
export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    user: null,
    token: null,
    userEmail: null,
    // refresh: localStorage.getItem('refreshtoken') || null,
    isLoading: false,
    isAuthenticated: false,
    error: null,
    isInitialized: false,
  });

  // Rehydrate state from localStorage when the app loads
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("user");
    const email = localStorage.getItem("email");

    if (token && user) {
      setAuth({
        user,
        userEmail: email || null,
        token,
        isAuthenticated: true,
        isLoading: false,
        error: null,
        isInitialized: true,
      });
    } else {
      setAuth((prevState) => ({
        ...prevState,
        isInitialized: true, // Even if there's no token, mark initialization as complete
      }));
    }
  }, []); // Run only once when the component mounts

  // Function to handle login
  const login = async (username, password) => {
    setAuth((prevState) => ({ ...prevState, isLoading: true, error: null }));
    try {
      const response = await axios.post(
        "https://test.youthplus.ng/onboard/login-account/",
        { username, password }
      );
      const data = response.data;
      localStorage.setItem("token", data.access);
      localStorage.setItem("email", data.email || "");
      localStorage.setItem("refreshToken", data.refresh);
      localStorage.setItem("user", data.username);
      localStorage.setItem("freshLogin", "true");

      if (data) {
        // console.log("userEmail", data.email)
        setAuth({
          user: data.username,
          token: data.access,
          userEmail: data.email,
          // refresh: data.refresh,
          isLoading: false,
          isAuthenticated: true,
          error: null,
          isInitialized: true,
        });
        // return{success:true}
      }
    } catch (error) {
      setAuth({
        user: null,
        userEmail: null,
        token: null,
        isLoading: false,
        isAuthenticated: false,
        error: error.response?.data?.detail || "Login failed",
        isInitialized: true,
      });
      throw error;
    }
  };

  // Function to handle logout
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("refreshToken");
    setAuth({
      user: null,
      token: null,
      userEmail: null,
      isLoading: false,
      isAuthenticated: false,
      error: null,
      isInitialized: true,
    });
  };
  const resetPassword = async (email) => {
    try {
      const response = await axios.post(
        "https://test.youthplus.ng/onboard/mobile/forgot-password/",
        { email }
      );
      const data = response.data;

      return data;
    } catch (error) {
      throw error;
    }
  };
  return (
    <AuthContext.Provider value={{ auth, login, logout, resetPassword }}>
      {children}
    </AuthContext.Provider>
  );
};
